import {getFilmDisplayTextData, getFilterDisplayTextData, getFormDisplayText, getMemberDisplayTextData, getOrderDisplayTextData, getPriceDisplayText, getSeatDisplayTextData, getShowtimeDisplayTextData, getSubscriptionDisplayTextData} from './displayText'

import {DisplayText} from '../types/initialiseDataFromBe'
import { NestedPartial } from '@vista/omnichannel-components-domain'
import {OccDisplayText} from '@vista/omnichannel-components-ui'
import {defaultOccDisplayText} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/display-text/display-text'

export interface GetDisplayTextDataProps {
    displayText?:NestedPartial<DisplayText>
}

export function getDisplayTextData(props:GetDisplayTextDataProps):OccDisplayText {
    const {displayText} = props;
    return {
        /**
     * The name of the cinema chain.
     *
     * @example 'ABC Cinemas'
     */
    cinemaChainName: displayText?.cinemaChainName || defaultOccDisplayText.cinemaChainName,
    /**
     * The title displayed when there's an unexpected error inside a component.
     */
    componentErrorTitle: displayText?.componentErrorTitle || defaultOccDisplayText.componentErrorTitle,
    /**
     * Message to be displayed when an empty result set is returned from a search.
     */
    noSearchResultsFoundMessage: displayText?.noSearchResultsFoundMessage || defaultOccDisplayText.noSearchResultsFoundMessage,
    /**
     * Film display text.
     */
    film: getFilmDisplayTextData({displayText}),
    /**
     * Filter display text.
     */
    filter: getFilterDisplayTextData(),
    /**
     * Form display text.
     */
    form: getFormDisplayText({displayText}),
    /**
     * Member display text.
     */
    member: getMemberDisplayTextData(),
    /**
     * Order display text.
     */
    order: getOrderDisplayTextData(),
    /**
     * Price display text.
     */
    price: getPriceDisplayText(),
    /**
     * Seat summary display text.
     */
    seat: getSeatDisplayTextData(),
    /**
     * Showtime display text.
     */
    showtime: getShowtimeDisplayTextData(),
    /**
     * Subscription and subscription billing option display text.
     */
    subscription: getSubscriptionDisplayTextData({displayText}),
    }
}